import { render, staticRenderFns } from "./ServiceAUXAlarm.vue?vue&type=template&id=205c74a8"
import script from "./ServiceAUXAlarm.vue?vue&type=script&lang=js"
export * from "./ServiceAUXAlarm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports